import compileInvalidFormField from '../../shared/util/invalid_form_field'

export default class BillingItemsList {

  constructor() {
    this.billingItems = []
  }

  addBillingItem(billingItem) {
    this.billingItems.push(billingItem)
  }

  billingItemsByType() {
    const itemsByType = {}

    this.billingItems.forEach((item) => {
      if (item.isDestroyed()) return

      itemsByType[item.itemType] ||= []
      itemsByType[item.itemType].push(item)
    })

    return itemsByType
  }

  totalAmount(items) {
    return items.reduce((sum, item) => sum + Number(item.fields.amount.value), 0)
  }

  isValid() {
    let allValid = true

    for (const items of Object.values(this.billingItemsByType())) {
      const upperLimit = Number(items[0].fields.upperLimit)
      if (!upperLimit) continue

      if (this.totalAmount(items) > upperLimit) {
        allValid = false
        items.forEach((item) => {
          item.markAsInvalid(item.fields.amount, this.totalAmountExceededMsg(item))
          compileInvalidFormField(item.fields.amount)
        })
      }
    }

    return allValid
  }

  totalAmountExceededMsg(billingItem) {
    return `Die Summe der Beträge der einzelnen Rechnungsposten vom Typ ${billingItem.humanizedItemType} überschreitet den erlaubten Maximalbetrag`
  }

}
